import { Key, useState } from 'react';

import { TreeDataType } from './type';

export const useCasTreeTransfer = () => {
  const [isLeftOnly, setIsLeftOnly] = useState<boolean>(false); // 控制是否只有左侧tree
  const handleIsLeftOnlyChange = (isLeftOnly: boolean) => {
    setIsLeftOnly(isLeftOnly);
  };
  const [finallyValue, setFinallyValue] = useState<Key[]>([]); // 最终返回给用户的key数组
  const handleFinallyValueChange = (value: Key[]) => {
    setFinallyValue(value);
  };

  const [defaultValue, setDefaultValue] = useState<Key[]>([]); // 主要用于保存默认值
  const handleDefaultValueChange = (arr: Key[]) => {
    setDefaultValue(arr);
  };

  const [sonParMap, setSonParMap] = useState<Map<Key, Key | null>>(new Map()); // 保存子节点key和父节点key的Map，主要用于子级查找父级
  const handleSonParMapChange = (map: Map<Key, Key | null>) => {
    setSonParMap(map);
  };

  const [flatArray, setFlatArray] = useState<any[]>([]); // 保存展平的树数据，用于重组树形结构
  const handleFlatArrayChange = (value: any[]) => {
    setFlatArray(value);
  };

  // 左边的树形选择框
  const [checkListLeft, setCheckListLeft] = useState<Key[]>([]); // 存储左侧选择框选中的key
  const handleCheckListLeftChange = (value: Key[]) => {
    setCheckListLeft(value);
  };
  const [isBrightLeft, setIsBrightLeft] = useState<boolean>(false); // 控制左侧按钮是否高亮
  const handleIsBrightLeftChange = (isBright: boolean) => {
    setIsBrightLeft(isBright);
  };

  const [readOnlyAllKeyLeft, setReadOnlyAllKeyLeft] = useState<Key[]>([]); // readonly 左边全部的key
  const handleReadOnlyAllKeyLeftChange = (arr: Key[]) => {
    setReadOnlyAllKeyLeft(arr);
  };

  const [indeterminateLeft, setIndeterminateLeft] = useState<boolean>(false); // 主要处理左侧的半选
  const handleIndeterminateLeftChange = (boo: boolean) => {
    setIndeterminateLeft(boo);
  };

  const [dataSourceLeft, setDataSourceLeft] = useState<TreeDataType>({
    treeData: [],
  }); // 左侧树形选择框的数据源
  const handleDataSourceLeftChange = ({ treeData }: TreeDataType) => {
    setDataSourceLeft({ treeData });
  };

  const [readOnlyTreeDataSource, setReadOnlyTreeDataSource] =
    useState<TreeDataType>({
      treeData: [],
    }); // 保存左侧树的数据源，用于只读，搜索
  const handleReadOnlyTreeDataSourceChange = ({ treeData }: TreeDataType) => {
    setReadOnlyTreeDataSource({ treeData });
  };

  // 右边的树形选择框
  const [checkListRight, setCheckListRight] = useState<Key[]>([]); // 存储在右侧选择框中的key
  const handleCheckListRightChange = (value: Key[]) => {
    setCheckListRight(value);
  };

  const [dataSourceRight, setDataSourceRight] = useState<TreeDataType>({
    treeData: [],
  }); // 右侧树形选择框的数据源
  const handleDataSourceRightChange = ({ treeData }: TreeDataType) => {
    setDataSourceRight({ treeData });
  };

  const [readOnlyAllKeyRight, setReadOnlyAllKeyRight] = useState<Key[]>([]); // 右侧所有的key
  const handleReadOnlyAllKeyRightChange = (arr: Key[]) => {
    setReadOnlyAllKeyRight(arr);
  };

  const [isBrightRight, setIsBrightRight] = useState<boolean>(false); // 控制右侧按钮是否高亮
  const handleIsBrightRightChange = (isBright: boolean) => {
    setIsBrightRight(isBright);
  };

  const [readOnlyDataSourceRight, setReadOnlyDataSourceRight] =
    useState<TreeDataType>({
      treeData: [],
    }); // 右侧只读的树形数据，主要用于搜索
  const handleReadOnlyDataSourceRightChange = ({ treeData }: TreeDataType) => {
    setReadOnlyDataSourceRight({ treeData });
  };
  const [disabled, setDisabled] = useState<boolean>(false); // 控制左右两侧的禁用
  const handleDisabledChange = (disabled: boolean) => {
    setDisabled(disabled);
  };

  return {
    finallyValue,
    checkListLeft,
    checkListRight,
    dataSourceRight,
    dataSourceLeft,
    defaultValue,
    flatArray,
    sonParMap,
    isBrightLeft,
    isBrightRight,
    indeterminateLeft,
    readOnlyAllKeyRight,
    readOnlyDataSourceRight,
    readOnlyAllKeyLeft,
    readOnlyTreeDataSource,
    disabled,
    isLeftOnly,
    handleFinallyValueChange,
    handleCheckListLeftChange,
    handleCheckListRightChange,
    handleDataSourceRightChange,
    handleDataSourceLeftChange,
    handleFlatArrayChange,
    handleSonParMapChange,
    handleReadOnlyAllKeyRightChange,
    handleReadOnlyDataSourceRightChange,
    handleIsBrightLeftChange,
    handleIsBrightRightChange,
    handleIndeterminateLeftChange,
    handleDefaultValueChange,
    handleReadOnlyAllKeyLeftChange,
    handleReadOnlyTreeDataSourceChange,
    handleDisabledChange,
    handleIsLeftOnlyChange,
  };
};
